module.exports = __webpack_public_path__ + "static/media/non_ulip.3e8bf550.mp3";